<template>
  <div class="chat-container">
    <div class="button-container-debug">
      <div class="debugger-info">
        {{chatMode}}
      </div>
      <button class="btn btn-primary" @click="debug">
          Dialogue Debugger
      </button>
      <button class="btn btn-primary" @click="createDialogues">
        Create Dialogues for Customers
      </button>
      <div class="debugger-content">
          {{debugMsg}}
      </div>
    </div>
    <transition :enter-active-class="animations.slideUp.enter" :leave-active-class="animations.slideDown.leave" :name="animations.standard.name">
                <ChatSubscriber v-if="chatMode == 'subscriber' && ready"/>
                <ChatModerator v-if="chatMode == 'moderator' && ready"/>
                <ChatCustomer v-if="chatMode == 'customer' && ready"/>
    </transition>
  </div>
</template>

<script>
  
import { mapGetters } from "vuex";
import ChatSubscriber from "./chat_subscriber.vue";
import ChatModerator from "./chat_moderator.vue";
import ChatCustomer from "./chat_customer.vue";

export default {
  name: "Chat",
  data() {
    return {
        ready: false,
        debugMsg: [],
    }
  },
  components: {
    ChatSubscriber,
    ChatModerator,
    ChatCustomer
  },
  methods: {
    async createDialogues() {
      await this.$store.dispatch("chat/updateDialogues");      
      try {
        this.kunden.forEach(async (k) => {
          const kundeUser = k.user;
          await this.$store.dispatch("chat/createKundeDialogue", kundeUser);
        });
      } catch(err) {
        console.log(err);
        this.$toasted.show("Fehler Beim Erstellen der Dialoge", this.toasts.failure);
      }
    },
    async debug() {
      console.log("debug check for dialogues");      
      console.log(this.kunden[0]);    
    },
    async checkChatMode() {
      if(!this.chatReady) await this.$store.dispatch("chat/initChat");
      await this.$store.dispatch("chat/setChatMode");      
      this.ready = true;
    }
  },
  async mounted() {
    await this.checkChatMode()
  },    
  computed: {
    ...mapGetters({
      animations: "app/animations",
      user: "auth/user",
      toasts: "app/toasts",
      isAdmin: "auth/isAdmin",
      mods: "chat/mods",
      kunden: "app/kunden",
      chatMode: "chat/chatMode",
      chatReady: "chat/chatReady"
    }),
  },
};
</script>


<style scoped>
  .button-container-debug {
    display:none;
    justify-content: flex-start;
    align-items:center;
  }

  .button-container-debug .btn, 
  .button-container-debug div {
    margin:10px;
  }

  .debugger-info {
    padding:10px;
    background:white;
    color:black;
    border:1px solid black;
  }
</style>

